const getters = {
  calls: (state) => state.calls
};

export default {
  getters
};
